import { CampoInput } from '@componentsNew/Input/CampoInput';
import { useEffect, useState } from '@wordpress/element';

function Permalink({ nota, carregando }) {

  return (
    <>
      <CampoInput
        label={'Permalink do artigo'}
        nota={nota}
        carregando={carregando}
        desabilidato={true}
        campoEstrutura={'permalink'}
      />
    </>
  );
}

export default Permalink;
